(() => {
  const CONE_VARIANT_ID = 59295877497177;
  const GIFT_VARIANT_ID = 59302586777945;
  const GIFT_MARKER = 'henna_5_cones';
  const nativeFetch = window.fetch.bind(window);

  let syncing = false;
  let queued = false;

  const isCartMutationUrl = (input) => {
    const value = typeof input === 'string' ? input : input?.url || '';
    try {
      const url = new URL(value, window.location.origin);
      return /\/cart\/(add|change|update)(\.js)?$/.test(url.pathname);
    } catch (_) {
      return /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(value);
    }
  };

  const readCart = async () => {
    const response = await nativeFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(`Cart read failed: ${response.status}`);
    return response.json();
  };

  const addGift = async () => {
    const response = await nativeFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            _ltz_gift: GIFT_MARKER,
            Cadeau: 'Offert dès 5 cônes',
          },
        }],
      }),
    });
    if (!response.ok) throw new Error(`Gift add failed: ${response.status}`);
  };

  const changeGiftLine = async (key, quantity) => {
    const response = await nativeFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error(`Gift change failed: ${response.status}`);
  };

  const syncGift = async () => {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;
    let changed = false;

    try {
      const cart = await readCart();
      const coneQty = cart.items.reduce(
        (sum, item) => sum + (Number(item.variant_id) === CONE_VARIANT_ID ? Number(item.quantity || 0) : 0),
        0
      );

      const giftLines = cart.items.filter(
        (item) =>
          Number(item.variant_id) === GIFT_VARIANT_ID &&
          item.properties &&
          item.properties._ltz_gift === GIFT_MARKER
      );

      if (coneQty >= 5) {
        if (giftLines.length === 0) {
          await addGift();
          changed = true;
        } else {
          const [firstGift, ...extraGifts] = giftLines;

          if (Number(firstGift.quantity) !== 1) {
            await changeGiftLine(firstGift.key, 1);
            changed = true;
          }

          for (const extraGift of extraGifts) {
            await changeGiftLine(extraGift.key, 0);
            changed = true;
          }
        }
      } else {
        for (const gift of giftLines) {
          await changeGiftLine(gift.key, 0);
          changed = true;
        }
      }

      if (changed) {
        window.location.reload();
        return;
      }
    } catch (error) {
      console.warn('[LTZ henna gift]', error);
    } finally {
      syncing = false;
      if (!changed && queued) {
        queued = false;
        setTimeout(syncGift, 80);
      }
    }
  };

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    try {
      if (response.ok && isCartMutationUrl(args[0])) {
        setTimeout(syncGift, 120);
      }
    } catch (_) {}
    return response;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGift, { once: true });
  } else {
    syncGift();
  }

  window.addEventListener('pageshow', syncGift);
  document.addEventListener('shopify:section:load', syncGift);
})();